import { PageResponse } from '@/shared/interfaces/page-response'

export const EmptyPage = {
  items: [],
  number: 1,
  size: 10,
  total: 0,
}

export function emptyPage<T>(): PageResponse<T> {
  return {
    items: [],
    number: 1,
    size: 10,
    total: 0,
  }
}
